var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"p-4"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }